import Vue from "vue";
import App from "./App.vue";
import './style/element-variables.scss';
import router from "./router";
import store from "./store";
import $ from '@/assets/js/jquery/jquery.min.js';
window.jQuery = $;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
